
import React from 'react';
import { ShieldCheck, ExternalLink } from 'lucide-react';
import { BR, PT } from 'country-flag-icons/react/3x2';

const trademarks = [
    {
        country: 'Portugal',
        flag: PT,
        status: 'Registo concedido',
        number: '769566',
        numberLabel: 'Marca nacional',
        institute: 'INPI Portugal',
        date: '21/09/2026',
        dateLabel: 'Data da concessão',
        url: 'https://servicosonline.inpi.pt/pesquisas/main/marcas.jsp?lang=PT',
        registered: true,
    },
    {
        country: 'Brasil',
        flag: BR,
        status: 'Registo concedido',
        number: '943849039',
        numberLabel: 'Número do processo',
        institute: 'INPI Brasil',
        date: '23/05/2026',
        dateLabel: 'Data do depósito',
        url: 'https://www.gov.br/inpi/pt-br/servicos/marcas',
        registered: true,
    },
];

const TrademarkRegistrations = () => {
    return (
        <section
            id="trademark-registrations"
            className="relative w-full overflow-hidden border-t border-white/10 bg-[#0B1120] py-20"
        >
            <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">

                <div className="mx-auto mb-12 max-w-3xl text-center">
                    <ShieldCheck
                        className="mx-auto mb-5 h-10 w-10 text-amber-400"
                        aria-hidden="true"
                    />

                    <h2 className="mb-5 text-3xl font-bold text-white md:text-4xl">
                        Marca e Propriedade Intelectual
                    </h2>

                    <p className="text-base leading-relaxed text-white/60">
                        A WSJ Soluções Digitais investe na proteção da sua
                        identidade e na valorização da sua marca em
                        Portugal e no Brasil.
                    </p>
                </div>

                <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
                    {trademarks.map((item) => (
                        <article
                            key={item.number}
                            className={`rounded-2xl border bg-white/[0.04] p-6 transition-all duration-300 sm:p-8 ${item.registered
                                    ? 'border-emerald-400/30 hover:border-emerald-400/60'
                                    : 'border-amber-400/30 hover:border-amber-400/60'
                                }`}
                        >
                            <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
                                <h3 className="flex items-center gap-3 text-xl font-bold text-white">
                                    <span
                                        className="lang-flag inline-flex h-5 w-8 shrink-0 items-center justify-center overflow-hidden rounded-sm border border-white/20 shadow-sm [&_svg]:!block [&_svg]:!h-full [&_svg]:!w-full [&_svg]:!size-auto [&_svg]:!max-h-none [&_svg]:!max-w-none"
                                        aria-hidden="true"
                                    >
                                        <item.flag className="block h-full w-full" focusable="false" />
                                    </span>

                                    <span>{item.country}</span>
                                </h3>

                                <span
                                    className={`rounded-full px-3 py-1 text-xs font-semibold ${item.registered
                                            ? 'bg-emerald-500/10 text-emerald-300'
                                            : 'bg-amber-500/10 text-amber-300'
                                        }`}
                                >
                                    {item.status}
                                </span>
                            </div>

                            <p className="mb-2 text-lg font-semibold text-white">
                                WSJ SOLUÇÕES DIGITAIS
                            </p>

                            <p className="mb-5 text-sm text-white/40">
                                {item.institute} · Classe 42
                            </p>

                            <div className="mb-6 border-y border-white/10 py-5">
                                <p className="mb-1 text-xs uppercase tracking-wider text-white/50">
                                    {item.numberLabel}
                                </p>

                                <p
                                    className={`break-all text-2xl font-bold tracking-wide ${item.registered
                                            ? 'text-emerald-400'
                                            : 'text-amber-400'
                                        }`}
                                >
                                    {item.number}
                                </p>
                            </div>

                            <p className="mb-6 text-sm text-white/50">
                                {item.dateLabel}: {item.date}
                            </p>

                            <a
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl border px-5 py-3 text-center text-sm font-semibold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${item.registered
                                        ? 'border-emerald-400/40 text-emerald-300 hover:bg-emerald-400/10 focus-visible:outline-emerald-400'
                                        : 'border-amber-400/40 text-amber-300 hover:bg-amber-400/10 focus-visible:outline-amber-400'
                                    }`}
                            >
                                Verificar no INPI
                                <ExternalLink className="h-4 w-4" aria-hidden="true" />
                            </a>
                        </article>
                    ))}
                </div>

                <p className="mx-auto mt-8 max-w-3xl text-center text-xs leading-relaxed text-white/40">
                    WSJ Soluções Digitais — marca registada em Portugal
                    sob o n.º 769566 e pedido de registo no Brasil
                    sob o n.º 943849039, ambos na classe 42.
                    Informações disponíveis para consulta nos
                    respetivos Institutos Nacionais da Propriedade Industrial.
                </p>

            </div>
        </section>
    );
};

export default TrademarkRegistrations;
